export default "/react/logoEmailMaker-811fe745.png";